/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from "@angular/core";
import {AbstractResourceService, JsonApiResource} from "@irian-ro/abstract-resource";
import {SignupFirstContactDto, SignupFirstContactMeta} from "@well/domain";
import { HttpClient } from "@angular/common/http";
import {EnvironmentService} from "@irian-ro/util-environment";
import {Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class SignupFirstContactResourceService extends AbstractResourceService<SignupFirstContactDto, SignupFirstContactDto, any, any>{

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(httpClient,
      environmentService.getEnvironmentProperty('signupFirstContactUrl'),
      SignupFirstContactDto,
      SignupFirstContactDto);
  }

  getTemplate(): Observable<JsonApiResource<SignupFirstContactDto, SignupFirstContactMeta>>{
    return <Observable<JsonApiResource<SignupFirstContactDto, SignupFirstContactMeta>>>this.httpClient?.get(`${this.url}/template`);
  }

}
